export default "__VITE_ASSET__BP5GZG3i__"